import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryTransportsSelectorData =
  Content.Components['TransportsSelectorModuleDto'];

interface UseQueryTransportsSelectorOptions {
  enabled?: boolean;
  initialData?: UseQueryTransportsSelectorData;
  parameters?: Content.Components['IHotelPageHeadlessParameters'] & {
    id: string;
    originalTransportMode?: Content.Components['TransportMode'];
    pageId: string;
  };
}

const useQueryTransportsSelector = ({
  enabled = true,
  initialData,
  parameters,
}: UseQueryTransportsSelectorOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQueryTransportsSelectorData>(
    [QueryId.TRANSPORTS_SELECTOR, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/transports-selector';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryTransportsSelector', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryTransportsSelector;
